var _path, _path2, _path3, _g, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOther(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 332,
    viewBox: "0 0 266 332",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.38129e-06 89.9998V295C-0.00265177 304.623 3.81687 313.853 10.6185 320.66C17.4202 327.467 26.647 331.294 36.27 331.3H228.79C238.417 331.3 247.65 327.475 254.458 320.668C261.266 313.86 265.09 304.627 265.09 295V36.3097C265.09 26.6823 261.266 17.4493 254.458 10.6417C247.65 3.83415 238.417 0.00976562 228.79 0.00976562H90.01L18.84 71.1597L1.38129e-06 89.9998Z",
    fill: "#F7F7FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 89.9998L18.84 71.1597L90.01 0.00976562H228.79C238.417 0.00976563 247.65 3.83415 254.458 10.6417C261.266 17.4493 265.09 26.6823 265.09 36.3097V120.67H0V89.9998Z",
    fill: "#B66B12"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 90.0002L44.4301 99.8102C53.8585 101.757 63.674 99.8783 71.7175 94.5879C79.7609 89.2975 85.3733 81.0286 87.32 71.6002L89.1801 61.4102C88.5907 64.2176 87.6569 66.9415 86.4 69.5201C83.429 75.6587 78.7883 80.8359 73.01 84.4581C67.2318 88.0804 60.5498 90.0012 53.73 90.0002H0Z",
    fill: "#D7D7D7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 90H53.73C60.5498 90.0009 67.2318 88.0801 73.01 84.4579C78.7883 80.8356 83.429 75.6584 86.4 69.5199C88.7704 64.579 90.004 59.17 90.01 53.6899V0L18.84 71.1599L0 90Z",
    fill: "#EFEFEF"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3181 270.9L57.0781 237.67L90.3181 204.43L98.1881 212.3L72.8281 237.67L98.1881 263.03L90.3181 270.9Z",
    fill: "#B66B12"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M174.771 270.9L166.891 263.03L192.261 237.67L166.891 212.3L174.771 204.43L208.011 237.67L174.771 270.9Z",
    fill: "#B66B12"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M144.75 191.432L109.973 279.72L120.338 283.803L155.115 195.515L144.75 191.432Z",
    fill: "#B66B12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther);
export default __webpack_public_path__ + "static/media/other.d2121e4a8950a5f930d1656ed6119072.svg";
export { ForwardRef as ReactComponent };